import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_SERVER_BASE_URI,
  timeout: process.env.VUE_APP_AJAX_TIMEOUT_IN_MILLISECONDS,
  withCredentials: true,
  crossDomain: true,
});

export default instance;
